import { render } from "./NewExams.vue?vue&type=template&id=036c8933&scoped=true"
import script from "./NewExams.vue?vue&type=script&lang=js"
export * from "./NewExams.vue?vue&type=script&lang=js"

import "./NewExams.vue?vue&type=style&index=0&id=036c8933&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036c8933"]])

export default __exports__